import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Tag } from 'src/app/interfaces/api/category';

type ActiveFilters = { [key: string]: string };

@Component({
  selector: 'app-modal-filter',
  templateUrl: './modal-filter.component.html',
  styleUrls: ['./modal-filter.component.scss'],
})
export class ModalFilterComponent implements OnInit {
  @Input() filterList: { type: string; tags: Tag[] }[];
  @Input() initialActiveTags: number[];
  activeFilters: number[] = [];

  constructor(private modalController: ModalController) {}

  ngOnInit() {
    if (this.initialActiveTags && this.initialActiveTags.length > 0) {
      this.activeFilters = [...this.initialActiveTags];
    }
  }

  isActiveFilter(tagId: number) {
    const isTagExist = this.activeFilters.findIndex(t => t === tagId) !== -1;
    return isTagExist;
  }

  setActiveFiters(tagId: number) {
    const tagIndex = this.activeFilters.indexOf(tagId);

    if (tagIndex !== -1) {
      this.activeFilters.splice(tagIndex, 1);
    } else {
      this.activeFilters.push(tagId);
    }
  }

  reset() {
    this.activeFilters = [];
    this.modalController.dismiss({ activeFilters: this.activeFilters }, 'confirm');
  }

  applyFilter() {
    this.modalController.dismiss({ activeFilters: this.activeFilters }, 'confirm');
  }

  cancel() {
    this.modalController.dismiss({ activeFilters: this.initialActiveTags }, 'cancel');
  }
}
